var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1330_27898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40416 7.97027C8.01809 8.40943 7.54816 8.77058 7.01942 9.03108V10.5311C7.01942 10.6637 6.96675 10.7909 6.87298 10.8846C6.77921 10.9784 6.65203 11.0311 6.51942 11.0311H3.51942C3.38682 11.0311 3.25964 10.9784 3.16587 10.8846C3.0721 10.7909 3.01942 10.6637 3.01942 10.5311V9.03108C2.29987 8.67405 1.689 8.13094 1.25022 7.45811C0.811446 6.78528 0.560762 6.00727 0.524197 5.20485C0.487632 4.40242 0.666517 3.60484 1.04228 2.89489C1.41805 2.18495 1.97699 1.58852 2.66109 1.16754C3.34519 0.746553 4.12951 0.516354 4.93262 0.50084C5.60263 0.487896 6.26534 0.62477 6.87298 0.899421",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01953 13.5H7.01953",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3921 3.93395C7.04117 3.8729 7.04117 3.36912 7.3921 3.30807C8.66345 3.08689 9.67464 2.11853 9.95059 0.857921L9.97175 0.761292C10.0476 0.414459 10.5415 0.4123 10.6204 0.758456L10.6461 0.871066C10.9323 2.12572 11.9437 3.08591 13.2116 3.30647C13.5643 3.36784 13.5643 3.87418 13.2116 3.93554C11.9437 4.15611 10.9323 5.1163 10.6461 6.37095L10.6204 6.48356C10.5415 6.82972 10.0476 6.82756 9.97175 6.48073L9.95059 6.3841C9.67464 5.1235 8.66345 4.15513 7.3921 3.93395Z",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1330_27898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai_icon.2fb065e4143ff5aaebf938bda1d6eaef.svg";
export { ForwardRef as ReactComponent };